import FEGORender from '@futuweb/fego-render';
import FEGOEditor from '@futuweb/fego-editor';

const PAGE_TYPE_ENUM = {
    H5: 1,
    PC: 10
};

export const isMoo = () => {
    if (FEGOEditor) {
        const { app } = FEGOEditor;
        const { domain } = app.project.appInfo;
        return domain.indexOf('moomoo.com') > -1;
    }
    // FEGORender 下，通过域名是否带 moomoo.com 判断是否 moomoo 下
    return location.host.indexOf('moomoo.com') > -1;
};

export const isH5 = () => {
    let route = null;
    if (FEGORender) {
        const { store } = FEGORender;
        route = store.route;
    } else {
        const {
            app: { project }
        } = FEGOEditor;
        route = project.route;
    }

    return route.now.pageType === PAGE_TYPE_ENUM.H5;
};

export const getEditorLang = () => {
    const lang = FEGOEditor?.app?.project?.route?.now?.lang?.toLowerCase();
    let ret = '';
    switch (lang) {
        case 'en':
            ret = 'en-us';
            break;
        case 'cn':
            ret = 'zh-cn';
            break;
        case 'hk':
            ret = 'zh-hk';
            break;
        case 'ja':
            ret = 'ja';
            break;
        default:
            ret = 'en-us';
    }
    return ret;
};

export const getIsPreRender = () => {
    return FEGORender.common.env.isPreRender;
};

export const getEntity = () => {
    return window._extra['tool-date-formatter']?.options?.entity;
};
